import { render, staticRenderFns } from "./prop-65.vue?vue&type=template&id=5d8f16b6&"
import script from "./prop-65.vue?vue&type=script&lang=js&"
export * from "./prop-65.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports